<template>

</template>


<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {api} from "@/services/Api";

@Component({})
export default class ObjectViewer extends Vue {
  @Prop() uuid?: string



  async loadChildren() {
    const res = await api.get(api.core, "contract/asset/folder/" + this.uuid);
    if (res?.data) {
      console.log(res.data)
      this.$forceUpdate();
    }
  }

}
</script>


<style scoped>

</style>